import { app } from '../../../app';
import { Controller } from './header.controller';

app.component('userApplicationsHeader', {
    bindings: {account: '<'},
    controller: Controller,
    templateUrl: require('./header.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/user/applications/header.component.js